<lc-base-dialog [message]="data.message" [otherActions]="data.readonly ? [] : [data.cancelAction]" [primaryAction]="data.acceptAction" [title]="data.title" (actionClicked)="onActionClicked($event)">

  <ng-template #content>
    <form id="reason-form" [formGroup]="reasonForm">
      <!-- CSS class is for test selector only.  No UI implications. -->
      <p class="reason-message mat-body-1">{{data.message}}</p>

      <!-- if the modal contains editable fields -->
      @if (!data.readonly) {
        @if (data.acceptAction.text === 'Refund') {
          <lc-dropdown #orderDropdown class="store-order"
            displayPath="display" idPrefix="store-order"
            label="Order" placeholder="Please select an order to refund" valuePath="id" [formControl]="reasonForm.getControl('storeOrder')" [options]="orderOptions"
            (selectionChanged)="onOrderSelected(orderDropdown.selected?.model.id)" />
          @if (lineItemOptions?.length) {
            <lc-multiselect
              #dateSelect
              class="fx-1-1-0"
              displayPath="display"
              label="Line Items"
              valuePath="value"
              [deselectAllEnabled]="true"
              [displayOptions]="lineItemOptionsDisplay"
              [formControl]="reasonForm.get('lineItems')"
              [multiple]="true"
              [options]="lineItemOptions"
              (selectionChanged)="onLineItemSelected($event)"
              />
          }
        }
        <lc-dropdown class="reason" idPrefix="reason" label="Reason" placeholder="Please select a reason from the list" [formControl]="reasonForm.getControl('reason')" [options]="data.reasons" (selectionChanged)="changeReason()" />
        @if (!hideNotes) {
          <div>
            <lc-textarea idPrefix="reason-note" label="Details" placeholder="Please provide more details..." [formControl]="reasonForm.getControl('notes')" />
          </div>
        }
        @if (data.acceptAction.text === 'Refund') {
          <lc-textbox idPrefix="reason-amount" label="Refund"
            placeholder="$0" [formControl]="reasonForm.getControl('amount')" [inputMask]="refundMask" [maskDropSpecialCharacters]="true"
            />
          <div>The maximum refund can be up to {{ maxRefundAmount | currency }}</div>
        }
      }

      <!-- if the modal is readonly -->
      @if (data.readonly) {
        @if (reasonForm.getControl('reason').value) {
          <div class="mb-3">
            <div class="font-weight-bolder">REASON</div>
            <!-- CSS class is for test selector only.  No UI implications. -->
            <div class="reject-reason-text">{{reasonForm.getControl('reason').value}}</div>
          </div>
        }
        @if (reasonForm.getControl('notes').value) {
          <div>
            <div class="font-weight-bolder">DETAILS</div>
            <!-- CSS class is for test selector only.  No UI implications. -->
            <div class="reject-notes-text">{{reasonForm.getControl('notes').value}}</div>
          </div>
        }
      }
    </form>
  </ng-template>
</lc-base-dialog>
